import { render, staticRenderFns } from "./AiChatWidget.vue?vue&type=template&id=092a2444&scoped=true&"
import script from "./AiChatWidget.vue?vue&type=script&lang=js&"
export * from "./AiChatWidget.vue?vue&type=script&lang=js&"
import style0 from "./AiChatWidget.vue?vue&type=style&index=0&id=092a2444&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092a2444",
  null
  
)

export default component.exports